// Saudi mobile number validation & normalization.
// Accepts 05XXXXXXXX, 5XXXXXXXX, 9665XXXXXXXX, +9665XXXXXXXX, 009665XXXXXXXX.
// Returns canonical 05XXXXXXXX, or null if invalid.
export function normalizeSaudiPhone(v) {
  let s = String(v || "").trim().replace(/[\s-]/g, "");
  if (s.startsWith("00")) s = s.slice(2);
  s = s.replace(/^\+/, "");
  if (!/^\d+$/.test(s)) return null;
  if (s.startsWith("966")) s = s.slice(3);
  if (s.length === 9 && s.startsWith("5")) s = "0" + s;
  if (s.length === 10 && s.startsWith("05")) return s;
  return null;
}

export const SAUDI_PHONE_ERROR = "أدخل رقم جوال سعودي صحيح (يبدأ بـ 05 ويتكوّن من 10 أرقام)";
